(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = '.hero__media, .media-block__media';
  var SPEED = 0.15;
  var MAX_OFFSET = 50;
  var initialized = false;

  function collectElements() {
    var elements = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    return elements.filter(function (el) {
      return el.tagName !== 'VIDEO' && !el.closest('video, deferred-media');
    });
  }

  function init() {
    var elements = collectElements();
    if (!elements.length) return;

    elements.forEach(function (el) {
      el.classList.add('parallax-media');
    });

    var ticking = false;

    function update() {
      var viewportH = window.innerHeight;
      elements.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > viewportH + 100) return;
        var center = rect.top + rect.height / 2 - viewportH / 2;
        var offset = Math.max(Math.min(center * SPEED, MAX_OFFSET), -MAX_OFFSET);
        el.style.setProperty('--parallax-offset', offset.toFixed(1) + 'px');
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();

    if (!initialized) {
      initialized = true;
      document.addEventListener('shopify:section:load', function () {
        initialized = false;
        init();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
